import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function ObjectIdIsNotNullValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isEmpty = (control.value?.id == null) || (control.value == null);
      return isEmpty ? {isEmpty: true} : null;
    };
  }